import React, { useEffect, useState } from 'react'
import Layout from '../../Components/Layout'
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import EmployeeReson from './EmployeeReson';
import ExitInterviewQuestion from '../OffboardingConfig/ExitInterviewQuestion';
import OffboardingEmployeeStatus from './OffboardingEmployeeStatus';
import CompleteExitInterview from './CompleteExitInterview';
import "../../Assets/CSS/EmployeeOffboarding.css";
import axios from 'axios';

const EmployeeOffboarding = () => {

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("empreson");
    const [hasCreatedRequest, setHasCreatedRequest] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const token = localStorage.getItem("token");

  // 🔥 CHECK OFFBOARDING REQUEST ON LOAD
  useEffect(() => {
    fetchMyOffboardingRequest();
  }, []);

  const fetchMyOffboardingRequest = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/my-requests`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data && res.data.length > 0) {
        // ✅ Request already exists
        const existingRequest = res.data[0];

        setHasCreatedRequest(true);
        setRequestId(existingRequest.requestId);
        setActiveTab("cexitIntervie");
      } else {
        // ❌ No request yet
        setHasCreatedRequest(false);
        setActiveTab("empreson");
      }
    } catch (error) {
      console.error("Failed to fetch offboarding request", error);
    }
  };

 const handleTabClick = (tab) => {
  // BEFORE request creation → only Create allowed
  if (!hasCreatedRequest && tab !== "empreson") return;

  // AFTER request creation → Create tab NOT allowed
  if (hasCreatedRequest && tab === "empreson") return;

  setActiveTab(tab);
};


    return (
        <Layout>
            <div className="backgound-main-content p-3">         {/* TAB BUTTONS */}
                <div>
                    <p className="card-heading" style={{ margin: '0px', padding: '0px' }}>My Offboarding</p>
                    <p className="sub-card-heading" style={{ margin: '0px', padding: '0px', marginTop: '4px', }}>
                        Track your exit process and complete required actions
                    </p>
                </div>
                <div className="d-flex gap-2 mt-4">

                    {/* Create Offboarding empreson TAB */}


                    <button
                        className={activeTab === "empreson" ? "EmployeeStep" : "EmployeeStepBefore"}
                        // onClick={() => setActiveTab("empreson")}
                        onClick={() => handleTabClick("empreson")}
  disabled={hasCreatedRequest}
                      

                    >
                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="proicons:person" />
                                <span>Create Offboarding</span>
                            </div>
                        </div>

                        <div className="tab-right">
                            {(activeTab === "cexitIntervie" || activeTab === "letter" || activeTab === "offboadringEmp") ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />   
                            )}
                        </div>
                    </button>


                    {/* Complete Exit Interview */}
                    <button
                        className={activeTab === "cexitIntervie" ? "EmployeeStep" : "EmployeeStepBefore"}
                        // onClick={() => setActiveTab("cexitIntervie")}
                        onClick={() => handleTabClick("cexitIntervie")}
                    >

                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="icon-park-outline:write" />
                                <span>Complete Exit Interview</span>
                            </div>


                        </div>


                        <div className="tab-right">
                            {(activeTab === "offboadringEmp" || activeTab === "letter") ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />   // 👈 placeholder
                            )}
                        </div>

                    </button>
                    <button
                        className={activeTab === "offboadringEmp" ? "EmployeeStep" : "EmployeeStepBefore"}
                        // onClick={() => setActiveTab("offboadringEmp")}
                        onClick={() => handleTabClick("offboadringEmp")}
                    >
                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="material-symbols:pending" />
                                <span>Approval Status</span>
                            </div>
                        </div>
                        <div className="tab-right">
                            {activeTab === "letter" ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />

                            )}
                        </div>
                    </button>


                </div>


                {/* Render Selected Component */}
                <div className="mt-4">
                    {/* {activeTab === "empreson" && <EmployeeReson />} */}

                    {activeTab === "empreson" && (
            <EmployeeReson
              onCreated={(newRequestId) => {
                setHasCreatedRequest(true);
                setRequestId(newRequestId);
                setActiveTab("cexitIntervie");
              }}
            />
          )}

                    {/* {activeTab === "cexitIntervie" && <CompleteExitInterview setActiveTab={setActiveTab} />} */}

{activeTab === "cexitIntervie" && (
            <CompleteExitInterview
              requestId={requestId}
              setActiveTab={setActiveTab}
            />
          )}

                    {activeTab === "offboadringEmp" && <OffboardingEmployeeStatus setActiveTab={setActiveTab} />}



                </div>
            </div>

        </Layout>
    )
}

export default EmployeeOffboarding